let cachedSlugs: string[] | null = null;

export function seedBlogSlugs(slugs: string[]): void {
  if (!slugs.length) return;
  cachedSlugs = Array.from(new Set(slugs));
}

export function slugFromPath(p: string): string {
  const file = p.split('/').pop() ?? p;
  return file.replace(/\.mdx$/i, '');
}

export function getBlogSlugs(
  modules?: Record<string, unknown> | null,
): string[] {
  if (modules && Object.keys(modules).length > 0) {
    const slugs = Object.keys(modules)
      .map(slugFromPath)
      .filter(Boolean);
    if (slugs.length > 0) {
      cachedSlugs = slugs;
    }
    return slugs;
  }

  if (cachedSlugs && cachedSlugs.length > 0) {
    return cachedSlugs;
  }

  return [];
}
